import './MiniProgressBar.css';

export interface MiniProgressBarProps {
  completeness: number;
}

export function MiniProgressBar({ completeness }: MiniProgressBarProps) {
  return (
    <div className="mini-progress">
      <div className="mini-progress-labels">
        <span className="mini-progress-label">Профиль</span>
        <span className="mini-progress-value">{completeness}%</span>
      </div>
      <div className="mini-progress-track">
        <div
          className="mini-progress-fill"
          style={{ width: `${Math.min(100, Math.max(0, completeness))}%` }}
        />
      </div>
    </div>
  );
}
